"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationInsightsClient = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./models/index.js"), exports);
var applicationInsightsClient_js_1 = require("./applicationInsightsClient.js");
Object.defineProperty(exports, "ApplicationInsightsClient", { enumerable: true, get: function () { return applicationInsightsClient_js_1.ApplicationInsightsClient; } });
//# sourceMappingURL=index.js.map